export const state = {
  questionList: {},
  questionRecycleList: {},
  questionBank: {},
  questionBankRecycle: {},
};
export const getters = {
  questionList: (state) => state.questionList,
  questionRecycleList: (state) => state.questionRecycleList,
  questionBank: (state) => state.questionBank,
  questionBankRecycle: (state) => state.questionBankRecycle,
};
export const mutations = {
  setQuestionListParams(state, newValue) {
    state.questionList = newValue;
  },
  setQuestionRecycleListParams(state, newValue) {
    state.questionRecycleList = newValue;
  },
  setQuestionBankParams(state, newValue) {
    state.questionBank = newValue;
  },
  setQuestionBankRecycleParams(state, newValue) {
    state.questionBankRecycle = newValue;
  },
};
export const actions = {
  cacheQuestionListParams({ commit }, params) {
    commit("setQuestionListParams", params);
  },
  cacheQuestionRecycleListParams({ commit }, params) {
    commit("setQuestionRecycleListParams", params);
  },
  cacheQuestionBankParams({ commit }, params) {
    commit("setQuestionBankParams", params);
  },
  cacheQuestionBankRecycleParams({ commit }, params) {
    commit("setQuestionBankRecycleParams", params);
  },
};
